import { useLang } from "../context/LanguageContext";

const CLIENTS = [
  "Marriott",
  "Hilton",
  "Rotana",
  "Jumeirah",
  "Emaar Hospitality",
  "Rixos",
  "Address Hotels",
  "Millennium",
  "Sheraton",
  "Mövenpick",
  "Fairmont",
  "Grand Hyatt",
  "Waldorf Astoria",
  "Ritz-Carlton",
  "Kempinski",
  "Radisson Blu",
];

export function ClientsStrip() {
  const { t } = useLang();

  const renderLogo = (name, i, prefix) => (
    <div
      key={`${prefix}-${i}`}
      data-testid={`client-logo-${prefix}-${i}`}
      className="shrink-0 mx-6 flex items-center justify-center min-w-[160px] h-12"
    >
      <span className="font-display text-[17px] tracking-[0.08em] text-slate-400 hover:text-[#0891b2] transition-colors whitespace-nowrap uppercase">
        {name}
      </span>
    </div>
  );

  return (
    <section
      className="relative bg-white border-y border-slate-200 py-8 overflow-hidden"
      data-testid="clients-strip"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 mb-5">
        <p className="text-center text-[10px] tracking-[0.35em] text-slate-500 uppercase font-semibold">
          {t.clientsStrip.title}
        </p>
      </div>
      <div className="relative">
        {/* Left fade */}
        <div className="absolute inset-y-0 start-0 w-24 bg-gradient-to-e from-white to-transparent z-10 pointer-events-none"
             style={{ background: 'linear-gradient(to right, #ffffff 0%, rgba(255,255,255,0) 100%)' }} />
        {/* Right fade */}
        <div className="absolute inset-y-0 end-0 w-24 z-10 pointer-events-none"
             style={{ background: 'linear-gradient(to left, #ffffff 0%, rgba(255,255,255,0) 100%)' }} />

        <div className="flex animate-marquee-ltr">
          {[...CLIENTS, ...CLIENTS, ...CLIENTS].map((c, i) => renderLogo(c, i, "cs"))}
        </div>
      </div>
    </section>
  );
}
